import { isPlatform } from '@ionic/vue'

export default defineNuxtPlugin(async () => {
	const { isLocal, isDev } = useEnvironment()
	if (!isPlatform('capacitor') || (!isLocal && !isDev)) return

	const eruda = await import('eruda')
	eruda.default.init()
})
